import { z } from 'zod'

export const feedbackRatingSchema = z.enum(['up', 'down'])

export const feedbackSchema = z.object({
  id: z.string(),
  messageId: z.string(),
  rating: feedbackRatingSchema,
  comment: z.string().optional(),
  createdAt: z.string(),
})
export type Feedback = z.infer<typeof feedbackSchema>

export const knowledgeGapStatusSchema = z.enum(['open', 'resolved'])

export const knowledgeGapSchema = z.object({
  id: z.string(),
  question: z.string(),
  occurrenceCount: z.number().int().default(1),
  status: knowledgeGapStatusSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
})
export type KnowledgeGap = z.infer<typeof knowledgeGapSchema>

export const leadSchema = z.object({
  id: z.string(),
  sessionId: z.string(),
  name: z.string(),
  company: z.string().optional(),
  email: z.string(),
  consentAt: z.string(),
  pipedriveId: z.string().nullable(),
  createdAt: z.string(),
})
export type Lead = z.infer<typeof leadSchema>
